var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgClose = function SvgClose(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2929 0.292892C14.6834 -0.0976294 15.3164 -0.0976309 15.707 0.292892C16.0974 0.683422 16.0975 1.31646 15.707 1.70695L9.41399 7.99992L15.707 14.2929C16.0974 14.6834 16.0975 15.3165 15.707 15.707C15.3165 16.0975 14.6834 16.0974 14.2929 15.707L7.99992 9.41399L1.70696 15.707C1.31646 16.0975 0.683423 16.0974 0.292893 15.707C-0.0976313 15.3164 -0.0976307 14.6834 0.292893 14.2929L6.58586 7.99992L0.292893 1.70695C-0.0976311 1.31643 -0.0976311 0.683416 0.292893 0.292892C0.683418 -0.0976301 1.31643 -0.0976315 1.70696 0.292892L7.99992 6.58586L14.2929 0.292892Z",
    fill: "white"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgClose);
export default ForwardRef;